import React, { useContext, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import {
    Button,
    Grid,
    Skeleton,
    TextField,
    Typography,
    Box,
    Fade,
    Zoom
} from '@mui/material';
import {
    AccountCircle,
    CloudUpload,
    Email,
    PhoneEnabled,
    Send
} from '@mui/icons-material';
import ContactC from '../Home_C/ContactC';
import { HomeContext } from '../../../Providers/HomeContext';

const {
    REACT_APP_URL_STORAGE,
} = process.env;

const useStyles = makeStyles((theme) => ({
    container: {
        background: 'radial-gradient(circle, rgba(187,187,187,1) 0%, rgba(143,143,143,1) 100%)',
        boxShadow: 'inset 0px 0px 40px 5px rgba(0,0,0,0.3)',
        minHeight: '800px',
        position: 'relative',
        overflow: 'hidden',
        padding: '40px 20px',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '-50%',
            left: '-50%',
            width: '200%',
            height: '200%',
            background: 'radial-gradient(circle, rgba(66, 131, 71, 0.15) 0%, transparent 70%)',
            animation: '$pulse 8s ease-in-out infinite',
        },
        [theme.breakpoints.down('md')]: {
            minHeight: '1200px',
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: '950px',
            padding: '20px 10px',
        },
    },
    '@keyframes pulse': {
        '0%, 100%': {
            transform: 'translate(0, 0) scale(1)',
        },
        '50%': {
            transform: 'translate(10%, 10%) scale(1.1)',
        },
    },
    '@keyframes float': {
        '0%, 100%': {
            transform: 'translateY(0px)',
        },
        '50%': {
            transform: 'translateY(-20px)',
        },
    },
    '@keyframes shimmer': {
        '0%': {
            backgroundPosition: '-100px 0',
        },
        '100%': {
            backgroundPosition: '10000px 0',
        },
    },
    inputContainer: {
        minHeight: '380px',
        marginTop: '20px',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(245,245,255,0.98) 100%)',
        borderRadius: '24px',
        boxShadow: '0px 8px 32px rgba(81, 75, 162, 0.3), 0px 2px 8px rgba(0,0,0,0.2)',
        padding: '30px 20px',
        backdropFilter: 'blur(10px)',
        border: '2px solid rgba(255,255,255,0.5)',
        transition: 'all 0.3s ease',
    },
    input: {
        display: 'flex',
        alignItems: 'center',
        width: '90%',
        '& .MuiFilledInput-root': {
            backgroundColor: 'rgba(255,255,255,0.9)',
            borderRadius: '12px',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(118,75,162,0.1)',
            '&:hover': {
                backgroundColor: 'rgba(255,255,255,1)',
                border: '1px solid rgba(155, 152, 158, 0.3)',
            },
            '&.Mui-focused': {
                backgroundColor: 'rgba(255,255,255,1)',
                boxShadow: '0 0 0 3px rgba(88, 103, 167, 0.2)',
                border: '1px solid rgba(103, 109, 139, 0.5)',
            },
        },
        '& .MuiSvgIcon-root': {
            transition: 'all 0.3s ease',
        },
        '&:hover .MuiSvgIcon-root': {
            color: '#667eea !important',
            transform: 'scale(1.1)',
        },
    },
    txtHeader: {
        color: '#f3c83c',
        fontSize: '1.3rem',
        fontStyle: 'italic',
        fontWeight: '600',
        textShadow: '0px 2px 4px rgba(0,0,0,0.5), 0px 4px 8px rgba(66, 131, 71, 0.4)',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        },
    },
    header: {
        marginBottom: '8px',
        color: '#FFFFFF',
        fontSize: '4.5rem',
        fontWeight: '800',
        letterSpacing: '2px',
        background: 'linear-gradient(135deg, #FFFFFF 0%, #FFD700 50%, #FFA500 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: '$shimmer 20s linear infinite',
        backgroundSize: '200% auto',
        [theme.breakpoints.down('lg')]: {
            fontSize: '3.5rem',
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '3rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.8rem',
        },
    },
    btnEnv: {
        marginTop: '20px',
        padding: '12px 48px',
        fontSize: '1.1rem',
        fontWeight: '700',
        background: 'linear-gradient(135deg, #FFC837 0%, #FF8008 100%)',
        color: '#FFFFFF',
        borderRadius: '50px',
        textTransform: 'none',
        boxShadow: '0px 6px 20px rgba(255,128,8,0.4), 0px 2px 8px rgba(0,0,0,0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
            transform: 'translateY(-2px)',
            boxShadow: '0px 8px 28px rgba(255,128,8,0.6), 0px 4px 12px rgba(0,0,0,0.3)',
        },
        '&:active': {
            transform: 'translateY(0px)',
        },
    },
    imgContainer: {
        maxWidth: '680px',
        height: 'auto',
        paddingBottom: '10px',
        animation: '$float 6s ease-in-out infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('lg')]: {
            maxWidth: '600px',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: '600px',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '0px 10px',
        }
    },
    imgFlayer: {
        width: '100%',
        height: 'auto',
        maxHeight: '600px',
        objectFit: 'contain',
        borderRadius: '24px',
        boxShadow: '0px 12px 40px rgba(118,75,162,0.5), 0px 4px 16px rgba(0,0,0,0.3)',
        transition: 'all 0.4s ease',
        border: '3px solid rgba(255,255,255,0.3)',
        backgroundColor: 'rgba(255,255,255,0.1)',
        '&:hover': {
            transform: 'scale(1.02)',
            boxShadow: '0px 16px 50px rgba(118,75,162,0.6), 0px 6px 20px rgba(0,0,0,0.4)',
            border: '3px solid rgba(255,200,0,0.5)',
        },
    },
    skeleton: {
        width: '100%',
        height: '100%',
        borderRadius: '24px',
        transform: 'none',
    },
    headerContainer: {
        position: 'relative',
        zIndex: 1,
        marginBottom: '40px',
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, rgba(102,126,234,0.1) 0%, rgba(118,75,162,0.1) 100%)',
        marginRight: '12px',
        transition: 'all 0.3s ease',
    },
}));

const controllerContact = new ContactC();

const FormworkV = ({ cerrarModal }) => {
    const { setAlert, urlFlayer } = useContext(HomeContext);
    const classes = useStyles();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [arch, setArch] = useState(null);
    const [error, setError] = useState(false);

    const sendEmail = () => {
        if (name !== '' && email !== '' && telefono !== '') {
            setAlert({ mensagge: 'Enviando...', type: 'info', status: true });
            const param = {
                name: name,
                email: email,
                arch: arch,
                mensagge: 'Postulacion',
                telefono: telefono,
                tipo: 'postulacion'
            }
            controllerContact.sendEmail(param)
                .then(resp => {
                    if (resp.ok) {
                        setAlert({ mensagge: 'Email enviado correctamente', type: 'success', status: true });
                        setName('');
                        setEmail('');
                        setTelefono('');
                        setError(false);
                    } else {
                        setError(true);
                        setAlert({ mensagge: 'Error al enviar email, intentelo nuevamente mas tarde.', type: 'error', status: true });
                        console.error(resp.mensagge)
                    }
                })
        } else {
            setError(true);
            setAlert({ mensagge: 'Complete todos los campos', type: 'error', status: true });
        }
    }

    return (
        <Grid container className={classes.container} id='formwork'>
            <Grid item container alignItems="center">
                <Grid item container justifyContent="center">
                    <Grid item container md={12} justifyContent="center" align="center" direction="column" className={classes.headerContainer}>
                        <Fade in={true} timeout={1000}>
                            <Grid item marginBottom={2}>
                                <Typography variant='h3' className={classes.header}>
                                    ¡SUMATE A NUESTRO EQUIPO!
                                </Typography>
                                <Typography variant='p' className={classes.txtHeader}>
                                    Forma parte de nuestro staff
                                </Typography>
                            </Grid>
                        </Fade>
                    </Grid>
                    <Grid container justifyContent='space-evenly' spacing={3}>
                        <Grid item className={classes.imgContainer}>
                            <Zoom in={true} timeout={800}>
                                <Box>
                                    {urlFlayer ? (
                                        <img
                                            src={REACT_APP_URL_STORAGE + urlFlayer}
                                            alt="Flyer Sumate a nuestro equipo"
                                            className={classes.imgFlayer}
                                        />
                                    ) : (
                                        <Skeleton
                                            variant="rectangular"
                                            className={classes.skeleton}
                                            animation="wave"
                                        />
                                    )}
                                </Box>
                            </Zoom>
                        </Grid>
                        <Grid item container direction='column' justifyContent='center' md={5}>
                            <Fade in={true} timeout={1200}>
                                <Grid item container justifyContent="center" alignItems="end" className={classes.inputContainer} spacing={2}>
                                    <Grid item container alignContent="center" direction="column" spacing={2}>
                                        <Grid item className={classes.input}>
                                            <Box className={classes.iconWrapper}>
                                                <AccountCircle sx={{ color: '#666', fontSize: '24px' }} />
                                            </Box>
                                            <TextField
                                                id="nombre"
                                                color="letters"
                                                label="Nombre completo"
                                                variant="filled"
                                                fullWidth
                                                error={error}
                                                value={name}
                                                onChange={(e) => {
                                                    setError(false)
                                                    setName(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item className={classes.input}>
                                            <Box className={classes.iconWrapper}>
                                                <Email sx={{ color: '#666', fontSize: '24px' }} />
                                            </Box>
                                            <TextField
                                                id="email"
                                                color="letters"
                                                label="Correo electrónico"
                                                variant="filled"
                                                fullWidth
                                                error={error}
                                                value={email}
                                                onChange={(e) => {
                                                    setError(false)
                                                    setEmail(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item className={classes.input}>
                                            <Box className={classes.iconWrapper}>
                                                <PhoneEnabled sx={{ color: '#666', fontSize: '24px' }} />
                                            </Box>
                                            <TextField
                                                id="telefono"
                                                color="letters"
                                                label="Teléfono de contacto"
                                                variant="filled"
                                                fullWidth
                                                error={error}
                                                value={telefono}
                                                onChange={(e) => {
                                                    setError(false)
                                                    setTelefono(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Button
                                        color='btn'
                                        variant='contained'
                                        className={classes.btnEnv}
                                        size='large'
                                        onClick={sendEmail}
                                        startIcon={<Send />}
                                    >
                                        Enviar postulación
                                    </Button>
                                </Grid>
                            </Fade>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default FormworkV